var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabylonjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    id: "Layer_1",
    viewBox: "-33.276 -64.0475 288.392 384.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs30590"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style30588"
  }, ".cls-1{fill:#fff}.cls-2{fill:#e0684b}.cls-3{fill:#bb464b}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path30594",
    d: "M110.92.01L0 64.01v128.11l110.92 64.07 110.92-64V64.04z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30596",
    className: "cls-2",
    d: "M264.5 128.09l34.72 20.05 33.4-19.29-34.72-20.04z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30598",
    className: "cls-2",
    d: "M221.7 64.81l-110.92 64.04 33.4 19.29L255.09 84.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30600",
    className: "cls-2",
    d: "M256.41 212.94l-34.71-20.05-34.72 20.05 34.72 20.04z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30602",
    className: "cls-3",
    d: "M221.7 282.41l-77.52-44.76v-89.51l-33.4-19.29v128.08l110.92 64.04 110.92-64.04V128.85l-33.4 19.29v89.51z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30604",
    className: "cls-3",
    d: "M186.98 212.94l34.72-20.05 34.71 20.05v-40.09l-34.71-20.04-34.72 20.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30606",
    fill: "#e0ded8",
    d: "M256.41 212.94l-34.71 20.04v49.43l77.52-44.76v-89.51l-42.81 24.71z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30608",
    fill: "#d5d2ca",
    d: "M186.98 212.94l34.72 20.04v49.43l-77.52-44.76v-89.51l42.8 24.71z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-110.78 -64.81)",
    id: "polygon30610",
    className: "cls-1",
    d: "M264.5 128.09l34.72 20.05-42.81 24.71-34.71-20.04-34.72 20.04-42.8-24.71L255.09 84.1l42.81 24.71z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabylonjs);
export default __webpack_public_path__ + "static/media/babylonjs.7d4352497f6b35931ac90180db6c0637.svg";
export { ForwardRef as ReactComponent };